import { memo, type ReactNode, useEffect, useState } from 'react'

import { Stack, Text } from '@mantine/core'

import { content_flash_detector } from '@repo/common/helpers/content_flash_detector'
import { useAuth, useRefresh } from '@repo/common/queries/auth'

export const RequireAccess = memo<{
  children: ReactNode
}>(function RequireAccess({ children }) {
  const { data, isSuccess: auth_checked } = useAuth()
  const { mutate: refresh, isSuccess } = useRefresh()
  const [has_check, set_has_check] = useState(false)

  useEffect(() => {
    if (!has_check && data != null && !data.is_support) {
      refresh()
      set_has_check(true)
    }
  }, [data, has_check, refresh])

  if (auth_checked == false) {
    return null
  }

  if (data.is_support) {
    return children
  }

  content_flash_detector.content_has_been_shown()

  return (
    <Stack maw="600px" align="center" mx="auto">
      <Text size="lg">You do not have permissions</Text>
      <Text>{!isSuccess && 'Rechecking...'}</Text>
    </Stack>
  )
})
